import MITable from 'components/common/grid/MITable';
import GlossaryExpandedView from './GlossaryExpandedView';

export const GridViewComponents: { [key: string]: any } = {
    default: MITable,
    glossaryExpanded: GlossaryExpandedView,
};
